export const Plugins = [
  "advlist",
  "autolink",
  "link",
  "image",
  "lists",
  "charmap",
  "preview",
  "anchor",
  "pagebreak",
  "searchreplace",
  "wordcount",
  "visualblocks",
  "visualchars",
  "code",
  "fullscreen",
  "insertdatetime",
  "media",
  "table",
  "emoticons",
  "template",
  "help",
  "quickbars",
];
